import { jsx as N } from "react/jsx-runtime";
import { createContext as R, forwardRef as k, useMemo as M, useImperativeHandle as j } from "react";
import { u as E, b as F, c as H, d as U, e as W, o as b, f as q, g as z, s as B, h as G } from "../../floating-ui.react-DxYXKqW-.js";
import { usePopoverState as J } from "./hooks/usePopoverState.js";
import { usePopoverNavigation as K } from "./hooks/usePopoverNavigation.js";
import { usePopoverAria as L } from "./hooks/usePopoverAria.js";
const Q = R(
  void 0
), V = k(
  ({
    align: p,
    children: w,
    defaultShow: x,
    disabledAutoToggle: t,
    onActivated: l,
    onDeactivated: c,
    onNavigate: P,
    type: r,
    show: C
  }, v) => {
    const u = p === "auto", e = J({
      defaultShow: x,
      show: C
    }), o = E({
      open: e.show,
      onOpenChange: (s, i, m) => {
        e.setShow(s), s && (l == null || l(i, m, n)), !s && (c == null || c(i, m, n));
      },
      middleware: [b(5), u ? q() : z(), B()],
      placement: u ? void 0 : p,
      whileElementsMounted: G
    }), g = F(o.context, {
      enabled: !t
    }), S = H(o.context, {
      enabled: !t
    }), I = U(o.context, {
      role: r
    }), { activeIndex: n, list: f, listNav: O } = K(
      o.context,
      r,
      {
        focusItemOnOpen: !0
      },
      P
    ), a = L(), h = W([g, S, I, O]), d = M(
      () => ({
        ...a,
        ...e,
        api: o,
        activeIndex: n,
        disabledAutoToggle: t,
        interactions: h,
        list: f,
        setShowWithReason: (s, i, m) => o.context.onOpenChange(s, i, m),
        type: r
      }),
      [
        n,
        o,
        a,
        t,
        h,
        f,
        e,
        r
      ]
    );
    return j(
      v,
      () => ({
        getContent: () => o.elements.floating,
        setShow: e.setShow,
        show: e.show,
        toggleAriaControls: a.toggleAriaControls
      }),
      [o.elements.floating, a.toggleAriaControls, e]
    ), /* @__PURE__ */ N(Q.Provider, { value: d, children: w });
  }
);
V.displayName = "PopoverProvider";
export {
  Q as PopoverContext,
  V as PopoverProvider
};
